import { createContext, useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import useEventBus from "../../hooks/useEventBus";
import { customerPreferenceCookie } from "../../constants";

const PrivacyContext = createContext({});

export const PrivacyContextProvider = ({ children }) => {
  const [customerPreferences, setCustomerPreferences] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEventBus("onetrust.consentChanged", (consentIds) => {
    const consentArray = consentIds.split(",");
    if (mountedRef.current) {
      setCustomerPreferences(consentArray.includes(customerPreferenceCookie));
    }
  });

  return (
    <PrivacyContext.Provider value={{ customerPreferences }}>
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => useContext(PrivacyContext);

PrivacyContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
